var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiRrCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_46837)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_46837)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#B7281E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 7.99982C19.8124 7.81235 19.5581 7.70703 19.2929 7.70703C19.0278 7.70703 18.7735 7.81235 18.5859 7.99982L15.9999 10.5858L13.4139 7.99982C13.2253 7.81766 12.9727 7.71687 12.7105 7.71914C12.4484 7.72142 12.1975 7.82659 12.0121 8.012C11.8267 8.19741 11.7216 8.44822 11.7193 8.71042C11.717 8.97261 11.8178 9.22522 11.9999 9.41382L14.5859 11.9998L11.9999 14.5858C11.8178 14.7744 11.717 15.027 11.7193 15.2892C11.7216 15.5514 11.8267 15.8022 12.0121 15.9876C12.1975 16.173 12.4484 16.2782 12.7105 16.2805C12.9727 16.2828 13.2253 16.182 13.4139 15.9998L15.9999 13.4138L18.5859 15.9998C18.7745 16.182 19.0271 16.2828 19.2893 16.2805C19.5515 16.2782 19.8023 16.173 19.9878 15.9876C20.1732 15.8022 20.2783 15.5514 20.2806 15.2892C20.2829 15.027 20.1821 14.7744 19.9999 14.5858L17.4139 11.9998L19.9999 9.41382C20.1874 9.22629 20.2927 8.97198 20.2927 8.70682C20.2927 8.44165 20.1874 8.18735 19.9999 7.99982Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C13.6266 0 11.3066 0.703788 9.33316 2.02236C7.35977 3.34094 5.8217 5.21509 4.91345 7.4078C4.0052 9.60051 3.76756 12.0133 4.23058 14.3411C4.6936 16.6689 5.83649 18.8071 7.51472 20.4853C9.19295 22.1635 11.3312 23.3064 13.6589 23.7694C15.9867 24.2324 18.3995 23.9948 20.5922 23.0866C22.7849 22.1783 24.6591 20.6402 25.9776 18.6668C27.2962 16.6935 28 14.3734 28 12C27.9966 8.81846 26.7312 5.76821 24.4815 3.51852C22.2318 1.26883 19.1815 0.00344108 16 0V0ZM16 22C14.0222 22 12.0888 21.4135 10.4443 20.3147C8.79981 19.2159 7.51809 17.6541 6.76121 15.8268C6.00433 13.9996 5.8063 11.9889 6.19215 10.0491C6.578 8.10929 7.53041 6.32746 8.92894 4.92893C10.3275 3.53041 12.1093 2.578 14.0491 2.19215C15.9889 1.8063 17.9996 2.00433 19.8268 2.7612C21.6541 3.51808 23.2159 4.79981 24.3147 6.4443C25.4135 8.08879 26 10.0222 26 12C25.9971 14.6513 24.9426 17.1931 23.0679 19.0679C21.1931 20.9426 18.6513 21.9971 16 22Z",
    fill: "#B7281E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_46837",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_46837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_46837",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_46837"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCrossCircle);
export default __webpack_public_path__ + "static/media/fi-rr-cross-circle.19c5c0b15c9ba9ca5342c367e01cae98.svg";
export { ForwardRef as ReactComponent };